import React, { Fragment } from "react";

const Accounts = ({ screenSize, menuToggle, onToggleMenu }) => {
  const importIcon = "https://res.cloudinary.com/dahddvlgy/image/upload/v1649627797/mad_wallet/images/import.png";
  const toggleIcon = "https://res.cloudinary.com/dahddvlgy/image/upload/v1651577439/mad_wallet/images/option-icon.png";
  return (
    <Fragment>
      <nav className="accounts">
        <div className="acct-item">
          <button className="mdw-nav__link-account">
            <img src={importIcon} alt="import from cloud" />
          </button>
        </div>
        <div className="acct-item">
          {
            (screenSize === 'desktop') ? (<span>EN</span>) : null
          }
        </div>
      </nav>

      <div className="toggle-box" onClick={ onToggleMenu }>
        <img src={toggleIcon} alt="toggle mobile menu"/>
      </div>
    </Fragment>
  );
};

export default Accounts;
